import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { Link } from "react-router-dom";

import { isExternal } from "../Anchor/Anchor";

const FooterLink = ({ name, link, className, ...props }) => {
  const classes = classnames("footer-section__item", className);

  return (
    <li className={classes} {...props}>
      {isExternal(link) || !link ? (
        <a rel="noopener noreferrer" href={link} className="footer-section__link" target="_blank">
          {name}
        </a>
      ) : (
        <Link to={link} className="footer-section__link">
          {name}
        </Link>
      )}
    </li>
  );
};
FooterLink.propTypes = {
  /**
   * Link text
   */
  name: PropTypes.string.isRequired,
  /**
   * Url of page to link to
   */
  link: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default FooterLink;
